/** Last day Legacy seat licenses were sold. */
export const LEGACY_SEAT_DISCONTINUED_ON = 'September 30, 2026'

export const LEGACY_SEAT_DISCONTINUED_LABEL = `Legacy seats discontinued as of ${LEGACY_SEAT_DISCONTINUED_ON}`

export const TIERS = [
  { tier: 1, seats: "10-30", instructors: 2, courses: 4 },
  { tier: 2, seats: "31-100", instructors: 2, courses: 6 },
  { tier: 3, seats: "101-250", instructors: 2, courses: 8 },
  { tier: 4, seats: "251-450", instructors: 3, courses: 14 },
  { tier: 5, seats: "451+", instructors: "TBD", courses: "Unlimited" },
];

export const LICENSE_CONFIG = {
  Legacy: {
    basePrice: 50,
    statePartnerPrice: 45,
    discountLabel: "State Partner 10% Off",
    discountPercent: 0.1,
    availability: LEGACY_SEAT_DISCONTINUED_LABEL,
    duration: "Active through 08/01/2028",
    durationDetail: "Legacy Seat Licenses already on an account stay active through 08/01/2028. New Legacy seats are not sold. Non-consumed Legacy licenses purchased prior to July 1, 2025 auto-convert to Basic on 10/01/2026. Purchases between July 1, 2025 and September 30, 2026 auto-convert to Basic on 08/01/2028. Conversions occur without refund or credit.",
    bestFor: "Existing accounts",
    povPacks: 1,
    learningActivities: "Basic",
    finalExam: false,
    category: "course",
  },
  "Supp. Legacy": {
    basePrice: 35,
    statePartnerPrice: 30,
    discountLabel: "State Partner ~14% Off",
    discountPercent: 0.14,
    availability: LEGACY_SEAT_DISCONTINUED_LABEL,
    duration: "Active through 08/01/2028",
    durationDetail: "Supplemental Pack Legacy Seat Licenses already on an account stay active through 08/01/2028. New Supplemental Legacy seats are not sold. Non-consumed Supplemental Legacy licenses purchased prior to July 1, 2025 auto-convert to Supplemental Basic on 10/01/2026. Purchases between July 1, 2025 and September 30, 2026 auto-convert to Supplemental Basic on 08/01/2028. Conversions occur without refund or credit.",
    bestFor: "Existing accounts",
    povPacks: 1,
    learningActivities: "Basic",
    finalExam: false,
    category: "supplemental",
  },
  "Supp. Basic": {
    basePrice: 35,
    statePartnerPrice: 30,
    discountLabel: "State Partner ~14% Off",
    discountPercent: 0.14,
    availability: "Ongoing",
    duration: "1 year from purchase date",
    durationDetail: "Each Supplemental Pack Basic Seat License purchase is individually logged and expires 1 year from its purchase date. Seats do not carry over to a new expiration date if additional seats are purchased later — each order has its own independent annual expiration. Unused seats expire with no cash value. Non-consumed Supplemental Basic seats may be upgraded to Supplemental Premium before expiration.",
    bestFor: "Supplemental content access",
    povPacks: 1,
    learningActivities: "Basic",
    finalExam: false,
    category: "supplemental",
  },
  "Supp. Premium": {
    basePrice: 50,
    statePartnerPrice: 45,
    discountLabel: "State Partner 10% Off",
    discountPercent: 0.1,
    availability: "Ongoing",
    duration: "Never expires",
    durationDetail: "Supplemental Pack Premium Seat Licenses never expire. If downgraded to Supplemental Basic, the transition date is logged and the seat begins its annual expiration from that date.",
    bestFor: "Full supplemental access",
    povPacks: 2,
    learningActivities: "Basic",
    finalExam: false,
    category: "supplemental",
  },
  Publications: {
    basePrice: 0,
    statePartnerPrice: 0,
    discountLabel: "",
    discountPercent: 0,
    availability: "Ongoing",
    duration: "Publications distribution",
    durationDetail: "Publications-only organizations purchase NFHS Digital titles per learner from the Publications tab. Upgrade to a Course Basic or Course Premium seat license to unlock courses, POV packs, learning activities, exams, and reports.",
    bestFor: "NFHS Digital publications distribution",
    povPacks: 0,
    learningActivities: "None",
    finalExam: false,
    category: "publications",
  },
  Basic: {
    basePrice: 50,
    statePartnerPrice: 45,
    discountLabel: "State Partner 10% Off",
    discountPercent: 0.1,
    availability: "Ongoing",
    duration: "1 year from purchase date",
    durationDetail: "Each Basic Seat License purchase is individually logged and expires 1 year from its purchase date. Seats do not carry over to a new expiration date if additional Basic seats are purchased later — each order has its own independent annual expiration. Unused seats expire with no cash value. Non-consumed Basic seats may be upgraded to Premium before expiration.",
    bestFor: "Core Content Instruction",
    povPacks: 1,
    learningActivities: "Basic",
    finalExam: false,
    category: "course",
  },
  Premium: {
    basePrice: 75,
    statePartnerPrice: 60,
    discountLabel: "State Partner 20% Off",
    discountPercent: 0.2,
    availability: "Ongoing",
    duration: "Never expires",
    durationDetail: "Premium Seat Licenses never expire. Includes 2 POV video packs per applicable sport, Basic + Premium Learning Activities, and 1 Practice Exam per sport course.",
    bestFor: "Comprehensive Course Instruction",
    povPacks: 2,
    learningActivities: "Basic + Premium",
    finalExam: true,
    category: "course",
  },
};

export const CONVERSION_INFO = {
  "Legacy→Basic": "Legacy seats convert to Basic at no upcharge. Converted seats expire 1 year from conversion date.",
  "Legacy→Premium": "Legacy seats convert to Premium with an upgrade fee per seat ($18.75 list / $15 state partner). Converted seats never expire.",
  "Basic→Premium": "Basic seats convert to Premium with an upgrade fee per seat ($18.75 list / $15 state partner). Converted seats never expire.",
  "Premium→Basic": "Premium seats convert to Basic with no refund. Converted seats are set to a 1-year expiration from conversion date.",
  "Supp. Legacy→Supp. Basic": "Supplemental Legacy seats convert to Supplemental Basic at no upcharge. Converted seats expire 1 year from conversion date.",
  "Supp. Legacy→Supp. Premium": "Supplemental Legacy seats convert to Supplemental Premium with an upgrade fee per seat. Converted seats never expire.",
  "Supp. Basic→Supp. Premium": "Supplemental Basic seats convert to Supplemental Premium with an upgrade fee per seat ($15/seat). Converted seats never expire.",
  "Supp. Premium→Supp. Basic": "Supplemental Premium seats convert to Supplemental Basic with no refund. Transition date is logged and seats begin annual expiration from that date.",
  "Supp. Basic→Basic": "Supplemental Basic seats upgrade to Course Basic. Upgrade fee applies per seat. Seats expire 1 year from conversion date.",
  "Supp. Basic→Premium": "Supplemental Basic seats upgrade to Course Premium. Upgrade fee applies per seat. Converted seats never expire.",
  "Supp. Premium→Basic": "Supplemental Premium seats upgrade to Course Basic. Upgrade fee applies per seat. Seats expire 1 year from conversion date.",
  "Supp. Premium→Premium": "Supplemental Premium seats upgrade to Course Premium. Upgrade fee applies per seat. Converted seats never expire.",
  "Publications→Basic": "Publications-only organizations upgrade to Course Basic. Upgrade fee applies per seat (Course Basic list price). Seats expire 1 year from conversion date.",
  "Publications→Premium": "Publications-only organizations upgrade to Course Premium. Upgrade fee applies per seat (Course Premium list price). Converted seats never expire.",
};
